import type { SrOrderStatus, SrSalesOrderType } from '@plato/data/starrocks/types';
import { OrderIcon } from '@plato/ui-legacy/assets/icons/order-icon';
import { QuoteIcon } from '@plato/ui-legacy/assets/icons/quote-icon';
import Text from '@plato/ui-legacy/components/ui/text';
import React from 'react';
import { useTranslation } from 'react-i18next';
import type { ActivityFeedRecord } from '../../../server/types/customer-activity-feed-types.ts';
import type { QuoteOrderPayload } from '../../../server/types/customer-activity.ts';
import { QuoteOrderLink } from '../../quote-order-detail/components/quote-order-link.tsx';
import { QuoteOrderTimelineBody } from '../../quote-order-timeline/components/quote-order-timeline-order.tsx';
import { TimelineList } from '../../shared/components/timeline-list/timeline-list.tsx';
import { OrderStatusBadge } from '../../statuses/components/order-status-badge.tsx';

export const ActivityFeedQuoteOrderItem = React.forwardRef<HTMLDivElement, { activity: ActivityFeedRecord }>(
    ({ activity }, ref) => {
        const { t } = useTranslation();
        const payload = activity.payload as QuoteOrderPayload;

        const transaction = {
            ...payload,
            id: payload.sales_order_id,
            type: activity.model_type as SrSalesOrderType,
            status: payload.status as SrOrderStatus,
            sales_order_items_count: payload.line_items_count,
            // TODO: replace this once backend return the right value
            order_created_at_date: new Date(`${payload.order_created_at_date}Z`.replace(/Z{2}$/, 'Z')),
            is_created_in_plato: false,
            sales_reps: [],
        };

        const optsMap: Record<
            string,
            {
                icon: React.ElementType;
                title: string;
            }
        > = {
            ORDER: {
                icon: OrderIcon,
                title: t('order'),
            },
            QUOTE: {
                icon: QuoteIcon,
                title: t('quote'),
            },
        };

        const opts = optsMap[activity.model_type];

        if (!opts) {
            return null;
        }

        return (
            <TimelineList.Item icon={opts.icon} ref={ref}>
                <TimelineList.ItemHeader className="flex flex-col sm:flex-row gap-2">
                    <div className="flex gap-1">
                        <Text>{opts.title}</Text>
                        <QuoteOrderLink type={transaction.type} transactionId={transaction.sales_order_id} />
                    </div>
                    <div>
                        <OrderStatusBadge status={transaction.status} type={transaction.type} />
                    </div>
                </TimelineList.ItemHeader>
                <TimelineList.ItemBody>
                    <QuoteOrderTimelineBody transaction={transaction} shouldPreLoadLineItems={false} />
                </TimelineList.ItemBody>
            </TimelineList.Item>
        );
    },
);
ActivityFeedQuoteOrderItem.displayName = 'ActivityFeedQuoteOrderItem';
//
